import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from 'react-i18next';
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { Action } from "../../types/toolbar";
import CustomModal from "../../components/ui/modal/modal.component";
import { useState } from "react";
import JobServiceForm from "../../components/service/jobServiceForm.component";
import { useHasPermission } from "../../contexts/auth";

export const JobServicesCatalogListActions = () => {
  const { t } = useTranslation();
  const [addOpened, setAddOpened] = useState<boolean>(false);
  const canAdd = useHasPermission("service.add_jobservice");

  const actions: Action[] = [{
    id: "add-new-service",
    icon: <AddIcon />,
    label: t("Add new service"),
    onClick: () => { setAddOpened(true) },
    disabled: !canAdd
  }];

  const handleAdded = () => {
    setAddOpened(false);
    window.dispatchEvent(new Event('jobServiceCatalogAdded'));
  };

  return (
    <>
      <Toolbar actions={actions} />
      <CustomModal
        opened={addOpened}
        setOpened={setAddOpened}
        title={t("Add new service")}
        content={
          <JobServiceForm onSuccess={handleAdded} />
        }
      />
    </>
  );
};
